import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import AppBar from '@mui/material/AppBar';
import { motion } from 'framer-motion';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import Feed from '../feed';
import { forwardRef, Fragment, useEffect, useRef, useState } from 'react';
import { DOMAIN } from '../../config';
import { Box, DialogContent, styled } from '@mui/material';
import CustomizedProgressBars from '../common/loading';
import AppSnackbar from '../common/appSnackbar';
import SearchOffIcon from '@mui/icons-material/SearchOff';

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="right" ref={ref} {...props} />;
});

export default function AVDialog({setOpenMovies,openMovies,matches,chipTitle}) {
  const [latest,setLatest] = useState(null)
  const latestRef = useRef(latest)
  const [page,setPage] = useState(1)
  const [loading,setLoading] = useState(false)
  const dialogRef = useRef(null)
  const [stopLoad,setStopLoad] = useState(false)
  const [empty,setEmpty] = useState(false)
  const touchStartRef = useRef(0);
  const [finished,setFinished] = useState(false)


  const handleSwipe = (event) => {
    const touchEndX = event.changedTouches[0].clientX;
    const swipeDistance = touchStartRef.current - touchEndX;
    const flag = (event.target.className=="MuiBox-root css-5lyvo3"||event.target.className == "MuiTypography-root MuiTypography-h6 css-1miy0lu-MuiTypography-root"||event.target.className == "MuiTypography-root MuiTypography-body1 css-rizt0-MuiTypography-root"||event.target.className == "swiper-slide swiper-slide-visible swiper-slide-active"||event.target.className == "" || event.target.className == "1" || event.target.className == "swiper-slide swiper-slide-visible swiper-slide-fully-visible swiper-slide-active" || event.target.className == "swiper-slide swiper-slide-active swiper-slide-visible" || event.target.className=="swiper-slide swiper-slide-visible swiper-slide-prev")

    if (swipeDistance > 120) { // 设定滑动距离阈值
      if(flag == true) return  
      setOpenMovies(false)
    }
  };

  const handleTouchStart = (event) => {
    event.stopPropagation()
    touchStartRef.current = event.touches[0].clientX;
  };

  const handleClose = () => {
    setOpenMovies(false);
  };

  const handleScroll = () => {
    if(stopLoad) return
    const { scrollTop, scrollHeight, clientHeight } = dialogRef.current
    if (scrollTop +1+ clientHeight >= scrollHeight) {
        setLoading(true)
        setStopLoad(true)
        fetch(`${DOMAIN}ywyminiappbot/av?page=${page+1}`)
        .then((response)=>response.json())
        .then((data)=>{
            if(data.length == 0 || data.length < 5) {
              setStopLoad(true)
              setFinished(true)
            }else{
              setStopLoad(false)
            }
            setPage(page+1)
            setLatest([...latest,...data])
            setLoading(false)
        })

    }
    
  }



  useEffect(()=>{
    if(openMovies){
      setLoading(true)

      const dialogElement = dialogRef.current;
      setPage(1)
      fetch(`${DOMAIN}ywyminiappbot/av?page=1`)
      .then((response)=>response.json())
      .then((data)=>{
        setLoading(false)

          if(data.length==0){
            setEmpty(true)
            setLatest(null)
            return 
          }
          setEmpty(false)
          setLatest(data)
          latestRef.current = data
          if (dialogElement) {
            dialogElement.addEventListener('scroll', handleScroll);
          }
      })
      

      return () => {
        setStopLoad(false)
        setEmpty(false)
        setPage(1)
        if (dialogElement) {
            dialogElement.removeEventListener('scroll', handleScroll);
        }
      }
    } 
    
  },[openMovies])

  return (
    <Box >
      <Dialog 
        fullScreen
        open={openMovies}
        onClose={handleClose}
        TransitionComponent={Transition}
        onTouchStart={handleTouchStart}
        onTouchEnd={handleSwipe}
        PaperProps={{
          onTouchStart: handleTouchStart,
          onTouchEnd: handleSwipe,
        }}
      >
       

       <AppBar
  position="sticky"
  elevation={0}
  sx={{
    backdropFilter: 'blur(12px)',
    WebkitBackdropFilter: 'blur(12px)',
    backgroundColor: 'rgba(255,255,255,0.25)',
    color: '#000',
  }}
>
  <Toolbar sx={{ minHeight: 45 }}>
    <motion.div
      initial={{ x: '100vw', opacity: 0 }} // 从屏幕最右边开始
      animate={{ x: 0, opacity: 1 }}      // 滑到既定位置
      transition={{ type: 'spring', stiffness: 300, damping: 30 }}
      style={{ display: 'flex', alignItems: 'center', gap: 8 }}
    >
      <IconButton
        edge="start"
        color="inherit"
        onClick={handleClose}
        aria-label="close"
      >
        <CloseIcon fontSize="small" />
      </IconButton>

      <Typography
        variant="subtitle1"
        component="div"
        sx={{ fontWeight: 500, fontSize: 16 }}
      >
        {chipTitle}
      </Typography>
    </motion.div>
  </Toolbar>
</AppBar>


        <DialogContent
  ref={dialogRef}
  onScroll={handleScroll}
  style={{
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    padding: 0,
    paddingTop:45,
    overflowY: 'auto', // 保证可以滚动
  }}
>
  {latest && 
    <Feed 
      matches={matches} 
      latest={latest} 
      setLatest={setLatest}
      isRemark={false}
      title={"AV专区"}
      fetchUrl={`${DOMAIN}ywyminiappbot/av`}
    />
  }
  {empty && (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        flexFlow: "row",
        padding: "200px 0",
        color: "#999"
      }}
    >
      <SearchOffIcon/>
      <Typography variant='h6' fontSize={14}>
        没有此内容，我们会尽快发布...
      </Typography>
    </Box>
  )}
  {loading && <CustomizedProgressBars />}
  {finished && (
    <Typography 
      variant='h6' 
      sx={{
        fontSize: 12,
        paddingBottom: 20,
        textAlign: "center",
        color: "#888",
        fontWeight: 350
      }}
    >
      已经是最后一条了～
    </Typography>
  )}
</DialogContent>

      </Dialog>
    </Box>
  );
}

const BlinkingButton = styled(Button)(({ theme }) => ({
    animation: 'blinking 1.8s infinite',
    
    '@keyframes blinking': {
      '0%': {
        opacity: 1,
      },
      '50%': {
        opacity: 0.7,
      },
      '100%': {
        opacity: 1,
      },
    },
  }));